module.exports = __webpack_public_path__ + "img/link.fd243e8f.png";